<div class="container">
	<!-- Header + date range -->
	<div class="row">
		<div class="col-12">
			<h1>Campaign Effort</h1>
			<div class="row">
				<div class="col-4" style="overflow: visible; position:relative">
					<label for="">Date Range</label>
					<app-form-range-date
						[(ngModel)]="dateRange_"
						(OnSelected)="dateSelected($event)"
						[position]="'right'"
						[range_type]="'RANGE_PAST'"
						[autoApply]="true"
					></app-form-range-date>
				</div>
				<div class="col-8" align="left">
					<button type="button" class="btn btn-secondary waves-effect waves-light" style="bottom: 0px; position:absolute" (click)="getReport()">Get Report</button>
				</div>
			</div>
		</div>
	</div>
	<br>

	<div class="row">
		<div class="col-12">
			<div class="card">
				<div class="card-body">

					<!-- Tabs — compact segmented control (mockup: "LMS+ Campaign Effort — Admin Portal.html" .toggle) -->
					<div class="effort-toggle mb-3">
						<button type="button" [class.on]="tab === 'campaign'" (click)="setTab('campaign')">By Campaign <span class="ce-tab-count">{{ campaignRows.length }}</span></button>
						<button type="button" [class.on]="tab === 'caller'" (click)="setTab('caller')">By Caller <span class="ce-tab-count">{{ callerRows.length }}</span></button>
					</div>

					<!-- Partial-data notice when an endpoint failed (resilient forkJoin) -->
					<div *ngIf="!loading && (disposFailed || callerTimesFailed)" class="alert alert-warning fs-12 py-2 d-flex align-items-center" style="gap:8px;">
						<i class="ri-error-warning-line"></i>
						<span *ngIf="callerTimesFailed && !disposFailed">Caller-times data is unavailable (endpoint error) — dial &amp; talk metrics show &ldquo;&mdash;&rdquo;. Lead, dispo &amp; campaign figures are unaffected.</span>
						<span *ngIf="disposFailed && !callerTimesFailed">Dispositions data is unavailable (endpoint error) — By Campaign and lead figures can&rsquo;t be shown; caller totals still render.</span>
						<span *ngIf="disposFailed && callerTimesFailed">Both data sources are currently unavailable (endpoint error). Please retry.</span>
					</div>

					<app-loader *ngIf="loading"></app-loader>

					<!-- ═══════════ BY CAMPAIGN ═══════════ -->
					<ng-container *ngIf="!loading && tab === 'campaign'">
						<ng-container *ngIf="!drillCampaign; else campaignDrill">
							<!-- KPI cards -->
							<div class="row">
								<div class="col-md-3 col-6">
									<div class="card border card-border-success"><div class="card-body py-2">
										<p class="text-muted mb-1 fs-11">Leads delivered</p>
										<h3 class="mb-0">{{ kpiCampaign.leads }}</h3>
									</div></div>
								</div>
								<div class="col-md-3 col-6">
									<div class="card border"><div class="card-body py-2">
										<p class="text-muted mb-1 fs-11">Prospects worked</p>
										<h3 class="mb-0">{{ kpiCampaign.worked | number }}</h3>
									</div></div>
								</div>
								<div class="col-md-3 col-6">
									<div class="card border"><div class="card-body py-2">
										<p class="text-muted mb-1 fs-11">Calls <span class="badge bg-light text-muted">est.*</span></p>
										<h3 class="mb-0">{{ talkFailed ? '—' : (kpiCampaign.calls | number) }}</h3>
									</div></div>
								</div>
								<div class="col-md-3 col-6">
									<div class="card border"><div class="card-body py-2">
										<p class="text-muted mb-1 fs-11">Talk time <span class="badge bg-light text-muted">est.*</span></p>
										<h3 class="mb-0">{{ talkFailed ? '—' : talk(kpiCampaign.talkMs) }}</h3>
									</div></div>
								</div>
								<div class="col-md-3 col-6">
									<div class="card border"><div class="card-body py-2">
										<p class="text-muted mb-1 fs-11">Worked / lead</p>
										<h3 class="mb-0">{{ kpiCampaign.workedPerLead | number: '1.0-0' }}</h3>
									</div></div>
								</div>
							</div>

							<!-- Campaign table -->
							<ngx-datatable class="material" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="15" [rows]="campaignRows" [scrollbarH]="true">
								<ngx-datatable-column name="Campaign" prop="campaign" headerClass="title-header" [width]="180">
									<ng-template let-row="row" ngx-datatable-cell-template>
										<span style="font-weight: 600;">{{ row.campaign }}</span>
										<div class="text-muted fs-11">{{ row.worked | number }} worked</div>
									</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Dispo mix" [sortable]="false" headerClass="title-header" [width]="200">
									<ng-template let-row="row" ngx-datatable-cell-template>
										<div class="progress" style="height: 9px;" [title]="row.noAnswer + ' no answer · ' + row.callback + ' callback · ' + row.bad + ' bad · ' + row.leads + ' lead'">
											<div class="progress-bar" [style.width.%]="pct(row.noAnswer, row.worked)" style="background:#40A0FC"></div>
											<div class="progress-bar" [style.width.%]="pct(row.callback, row.worked)" style="background:#FEBC4A"></div>
											<div class="progress-bar" [style.width.%]="pct(row.bad, row.worked)" style="background:#3F475D"></div>
											<div class="progress-bar" [style.width.%]="pct(row.leads, row.worked)" style="background:#50E7A6"></div>
										</div>
										<div class="fs-11 text-muted mt-1"><span style="color:#50E7A6">&#9679;</span> {{ row.leads }} leads is the payoff</div>
									</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Calls per campaign" prop="calls" headerClass="cell-center title-header" cellClass="cell-center" [width]="90">
									<ng-template let-row="row" ngx-datatable-cell-template>{{ talkFailed ? '—' : (row.calls | number) }}</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Talk time" prop="talkMs" headerClass="cell-center title-header" cellClass="cell-center" [width]="80">
									<ng-template let-row="row" ngx-datatable-cell-template>{{ talkFailed ? '—' : talk(row.talkMs) }}</ng-template>
								</ngx-datatable-column>
								<!-- <ngx-datatable-column name="Talk*" prop="talkMs" headerClass="cell-center title-header" cellClass="cell-center" [width]="70">
									<ng-template let-row="row" ngx-datatable-cell-template>{{ talk(row.talkMs) }}</ng-template>
								</ngx-datatable-column> -->
								<ngx-datatable-column name="Leads" prop="leads" headerClass="cell-center title-header" cellClass="cell-center" [width]="60">
									<ng-template let-row="row" ngx-datatable-cell-template><span style="font-weight:600">{{ row.leads }}</span></ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Time-to-lead" headerClass="cell-center title-header" cellClass="cell-center" [width]="90" [sortable]="false">
									<ng-template ngx-datatable-cell-template>
										<span class="ce-pending-tag" title="Needs first-dial timing (RingCentral). Dispo dates alone can't measure this honestly — single-dispo leads would falsely read 0 days and out-of-range first contacts truncate it.">pending</span>
									</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Worked/lead" prop="workedPerLead" headerClass="cell-center title-header" cellClass="cell-center" [width]="90">
									<ng-template let-row="row" ngx-datatable-cell-template><span [style.color]="wplColor(row.workedPerLead)" style="font-weight:700">{{ row.workedPerLead | number: '1.0-0' }}</span></ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Effort" prop="effortScore" headerClass="cell-center title-header" cellClass="cell-center" [width]="70">
									<ng-template let-row="row" ngx-datatable-cell-template>
										<svg class="ce-ring" viewBox="0 0 40 40" width="34" height="34">
											<circle cx="20" cy="20" r="16" fill="none" stroke="#E2E8F0" stroke-width="4" />
											<circle cx="20" cy="20" r="16" fill="none" [attr.stroke]="bandColor(row.effortScore)" stroke-width="4" stroke-linecap="round" [attr.stroke-dasharray]="ringDash(row.effortScore)" transform="rotate(-90 20 20)" />
											<text x="20" y="24" text-anchor="middle" class="ce-ring-num" [attr.fill]="bandColor(row.effortScore)">{{ row.effortScore }}</text>
										</svg>
									</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="" [sortable]="false" headerClass="cell-center title-header" cellClass="cell-center" [width]="110">
									<ng-template let-row="row" ngx-datatable-cell-template>
										<button class="btn btn-sm btn-outline-primary" (click)="openCampaign(row.campaign)">Leads &rarr;</button>
									</ng-template>
								</ngx-datatable-column>
							</ngx-datatable>
							<div class="fs-11 text-muted mt-2"><strong>Prospects worked</strong> = count of dispositions (real). <strong>Talk*</strong> = time in call, estimated (allocated from per-caller RingCentral time until per-campaign lands).</div>
						</ng-container>

						<ng-template #campaignDrill>
							<div class="d-flex align-items-center mb-3" style="gap: 12px;">
								<button class="btn btn-sm btn-outline-secondary" (click)="clearDrill()">&larr; All campaigns</button>
								<h5 class="mb-0">{{ drillCampaign }} — delivered leads</h5>
							</div>
							<ng-container *ngTemplateOutlet="leadsTable; context: { scope: 'campaign' }"></ng-container>
						</ng-template>
					</ng-container>

					<!-- ═══════════ BY CALLER ═══════════ -->
					<ng-container *ngIf="!loading && tab === 'caller'">
						<ng-container *ngIf="!drillCaller; else callerDrill">
							<!-- KPI cards -->
							<div class="row">
								<div class="col-md-3 col-6">
									<div class="card border card-border-success"><div class="card-body py-2">
										<p class="text-muted mb-1 fs-11">Leads</p>
										<h3 class="mb-0">{{ kpiCaller.leads }}</h3>
									</div></div>
								</div>
								<div class="col-md-3 col-6">
									<div class="card border"><div class="card-body py-2">
										<p class="text-muted mb-1 fs-11">Total dials <span class="badge bg-light text-muted">est.*</span></p>
										<h3 class="mb-0">{{ callerTimesFailed ? '—' : (kpiCaller.calls | number) }}</h3>
									</div></div>
								</div>
								<div class="col-md-3 col-6">
									<div class="card border"><div class="card-body py-2">
										<p class="text-muted mb-1 fs-11">Time in call <span class="badge bg-light text-muted">est.*</span></p>
										<h3 class="mb-0">{{ callerTimesFailed ? '—' : talk(kpiCaller.talkMs) }}</h3>
									</div></div>
								</div>
								<div class="col-md-3 col-6">
									<div class="card border"><div class="card-body py-2">
										<p class="text-muted mb-1 fs-11">Avg conversion</p>
										<h3 class="mb-0">{{ kpiCaller.avgConv | number: '1.1-1' }}%</h3>
									</div></div>
								</div>
							</div>

							<!-- Caller table (ranked by leads desc) -->
							<ngx-datatable class="material" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="15" [rows]="callerRows" [scrollbarH]="true">
								<ngx-datatable-column name="Caller" prop="name" headerClass="title-header" [width]="180">
									<ng-template let-row="row" ngx-datatable-cell-template>
										<div class="ce-caller-name">
											<span class="ce-avatar">{{ initials(row.name) }}</span>
											<div>
												<span style="font-weight: 600;">{{ row.name }}</span>
												<div class="mt-1">
													<span *ngIf="row.name === topProducer" class="badge bg-warning">&#9733; Top producer</span>
													<span *ngIf="row.name === bestConverter" class="badge bg-info">&#9650; Best conversion</span>
												</div>
											</div>
										</div>
									</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Dispos" prop="dispos" headerClass="cell-center title-header" cellClass="cell-center" [width]="80">
									<ng-template let-row="row" ngx-datatable-cell-template>{{ row.dispos | number }}</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Calls*" prop="calls" headerClass="cell-center title-header" cellClass="cell-center" [width]="80">
									<ng-template let-row="row" ngx-datatable-cell-template>{{ row.callerMetricsUnavailable ? '—' : (row.calls | number) }}</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Hot/Callbacks" prop="hot" headerClass="cell-center title-header" cellClass="cell-center" [width]="100">
									<ng-template let-row="row" ngx-datatable-cell-template>{{ row.hot | number }}</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Leads" prop="leads" headerClass="cell-center title-header" cellClass="cell-center" [width]="70">
									<ng-template let-row="row" ngx-datatable-cell-template><span style="font-weight:600">{{ row.leads }}</span></ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Prospects/lead" prop="prospectsPerLead" headerClass="cell-center title-header" cellClass="cell-center" [width]="100">
									<ng-template let-row="row" ngx-datatable-cell-template>{{ row.prospectsPerLead | number: '1.0-0' }}</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Talk*" prop="talkMs" headerClass="cell-center title-header" cellClass="cell-center" [width]="70">
									<ng-template let-row="row" ngx-datatable-cell-template>{{ row.callerMetricsUnavailable ? '—' : talk(row.talkMs) }}</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="Top campaign" prop="topCampaign" headerClass="title-header" [width]="150">
									<ng-template let-row="row" ngx-datatable-cell-template><span class="text-muted">{{ row.topCampaign }}</span></ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column name="" [sortable]="false" headerClass="cell-center title-header" cellClass="cell-center" [width]="110">
									<ng-template let-row="row" ngx-datatable-cell-template>
										<button class="btn btn-sm btn-outline-primary" (click)="openCaller(row.name)">Leads &rarr;</button>
									</ng-template>
								</ngx-datatable-column>
							</ngx-datatable>
							<div class="fs-11 text-muted mt-2"><strong>Dispos</strong> = prospects worked (real). <strong>Calls*</strong> &amp; <strong>Talk*</strong> = RingCentral, estimated. Ranked by leads; invariant <em>Calls &ge; Dispos &ge; Leads</em>.</div>
						</ng-container>

						<ng-template #callerDrill>
							<div class="d-flex align-items-center mb-3" style="gap: 12px;">
								<button class="btn btn-sm btn-outline-secondary" (click)="clearDrill()">&larr; All callers</button>
								<h5 class="mb-0">{{ drillCaller }} — secured leads</h5>
							</div>
							<ng-container *ngTemplateOutlet="leadsTable; context: { scope: 'caller' }"></ng-container>
						</ng-template>
					</ng-container>

				</div>
			</div>
		</div>
	</div>

	<!-- Shared leads drill table -->
	<ng-template #leadsTable let-scope="scope">
		<ngx-datatable class="material" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="15" [rows]="drillLeads" [scrollbarH]="true">
			<ngx-datatable-column name="Id" prop="id" headerClass="cell-center title-header" cellClass="cell-center" [width]="70"></ngx-datatable-column>
			<ngx-datatable-column name="Prospect" prop="prospect_name" headerClass="title-header" [width]="170"></ngx-datatable-column>
			<ngx-datatable-column name="Campaign" prop="campaign_name" headerClass="title-header" [width]="150"></ngx-datatable-column>
			<ngx-datatable-column name="Dispo" prop="dispo" headerClass="cell-center title-header" cellClass="cell-center" [width]="80">
				<ng-template let-row="row" ngx-datatable-cell-template>
					<span class="badge" [ngClass]="badgeColor(row.dispo)">{{ row.dispo }}</span>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="Secured" prop="date" headerClass="cell-center title-header" cellClass="cell-center" [width]="110">
				<ng-template let-row="row" ngx-datatable-cell-template>{{ row.date | utcToLocal : 'mediumDate' }}</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column name="" [sortable]="false" headerClass="cell-center title-header" cellClass="cell-center" [width]="140">
				<ng-template let-row="row" ngx-datatable-cell-template>
					<button class="btn btn-sm btn-primary" (click)="openLead(row, scope)">Effort receipt &rarr;</button>
				</ng-template>
			</ngx-datatable-column>
		</ngx-datatable>
	</ng-template>

	<!-- Lead Effort Receipt modal -->
	<ng-template #receiptModal let-modal>
		<div class="modal-header" *ngIf="selectedLead as lead">
			<h4 class="modal-title">
				{{ lead.prospect_name }}
				<span class="badge ms-2" [ngClass]="badgeColor(lead.dispo)">{{ lead.dispo }}</span>
			</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
		</div>
		<div class="modal-body" *ngIf="selectedLead as lead">
			<div class="row mb-3">
				<div class="col-4"><strong>Campaign:</strong> {{ lead.campaign_name }}</div>
				<div class="col-4"><strong>Secured:</strong> {{ lead.date | utcToLocal : 'medium' }}</div>
				<div class="col-4"><strong>Secured by:</strong> {{ lead.caller_name }}</div>
			</div>

			<!-- Dispos-to-secure headline -->
			<div class="card border card-border-success mb-3">
				<div class="card-body text-center py-3">
					<div class="display-5 mb-0">{{ dtsCurrent }}</div>
					<p class="text-muted mb-2">Dispos to secure · {{ receiptScope === 'caller' ? 'this caller' : 'campaign' }}</p>
					<button class="btn btn-sm btn-outline-secondary" (click)="toggleReceiptScope()">
						&#8646; {{ receiptScope === 'caller' ? 'campaign' : 'this caller' }}: {{ dtsAlt }}
					</button>
					<div class="fs-11 text-muted mt-2">Prospects worked to secure this lead — non-lead dispos since the previous lead in this campaign.</div>
				</div>
			</div>

			<!-- Qualification proof — PENDING placeholder (no data source; NOT fake ✓) -->
			<div class="ce-pending rounded p-3 mb-3">
				<div class="d-flex justify-content-between align-items-center mb-2">
					<strong class="text-muted">Lead — qualification proof</strong>
					<span class="badge ce-pending-badge">Pending — needs qualification data source</span>
				</div>
				<div class="ce-qual-row" *ngFor="let q of qualificationCriteria">
					<span class="ce-qual-mark">—</span> {{ q }}
				</div>
				<button type="button" class="btn btn-sm btn-outline-secondary mt-2" disabled title="Recording — pending RingCentral">
					<i class="ri-play-circle-line align-middle me-1"></i>Recording — pending RingCentral
				</button>
			</div>

			<!-- Effort summary tiles — RingCentral-dependent, shown PENDING (no fake numbers) -->
			<div class="row g-2 mb-3">
				<div class="col-6 col-md-3"><div class="ce-pending ce-tile rounded text-center p-2">
					<div class="ce-tile-val">—</div><div class="ce-tile-lbl">Dials</div>
					<div class="ce-pending-tag">pending RingCentral</div>
				</div></div>
				<div class="col-6 col-md-3"><div class="ce-pending ce-tile rounded text-center p-2">
					<div class="ce-tile-val">—</div><div class="ce-tile-lbl">Callers</div>
					<div class="ce-pending-tag">pending RingCentral</div>
				</div></div>
				<div class="col-6 col-md-3"><div class="ce-pending ce-tile rounded text-center p-2">
					<div class="ce-tile-val">—</div><div class="ce-tile-lbl">Talk time</div>
					<div class="ce-pending-tag">pending RingCentral</div>
				</div></div>
				<div class="col-6 col-md-3"><div class="ce-pending ce-tile rounded text-center p-2">
					<div class="ce-tile-val">—</div><div class="ce-tile-lbl">To secure</div>
					<div class="ce-pending-tag">pending — first-dial date</div>
				</div></div>
			</div>

			<!-- Context -->
			<div class="row mb-2">
				<div class="col-12"><strong>Notes:</strong></div>
				<div class="col-12"><div class="alert alert-light mb-2">{{ lead.notes || '—' }}</div></div>
			</div>
			<div class="row" *ngIf="leadDetails">
				<div class="col-4"><strong>Company:</strong> {{ leadDetails.company_name || '—' }}</div>
				<div class="col-4"><strong>Phone:</strong> {{ (leadDetails.primary_phone || lead.primary_phone) | phone }}</div>
				<div class="col-4"><strong>Employee size:</strong> {{ leadDetails.employee_size || '—' }}</div>
			</div>

			<!-- Call trail — PENDING empty-state (NOT fake rows) -->
			<div class="ce-pending ce-emptybox rounded text-center p-3 mt-3">
				<i class="ri-phone-line"></i>
				<div class="fw-semibold text-muted">Call trail</div>
				<div class="ce-pending-tag">Per-call dial trail — pending RingCentral feed</div>
			</div>

			<!-- RingCentral pending -->
			<div class="alert alert-secondary mt-3 mb-0 fs-12">
				<i class="ri-phone-line"></i> Per-call dial trail, durations &amp; recording come from <strong>RingCentral (pending)</strong> — not shown here. Dials &amp; talk are marked <strong>*</strong> until that feed is wired.
			</div>
		</div>
		<div class="modal-footer">
			<!-- Present to match the mockup, but wired to a no-op stub — never exports placeholder content -->
			<button type="button" class="btn btn-primary" (click)="exportReceiptPdf()" title="Send-ready PDF — coming soon (separate Hiram build)">
				<i class="ri-download-2-line align-middle me-1"></i>Export PDF <span class="badge bg-light text-muted ms-1">soon</span>
			</button>
			<button type="button" class="btn btn-outline-secondary" disabled title="Ask Vera — coming soon">
				✨ Ask Vera — coming soon
			</button>
			<button type="button" class="btn btn-light" (click)="modal.dismiss()">Close</button>
		</div>
	</ng-template>
</div>
